import React from 'react';
import { createStyles } from './styles';

interface InfoObject {
  [key: string]: string;
}

interface InfoSectionProps {
  mainInfo: InfoObject;
  actionsSection?: JSX.Element;
  itemStyles?: string;
}

const InfoSection = ({ mainInfo, actionsSection, itemStyles }: InfoSectionProps): JSX.Element => {
  const classes = createStyles();
  const proposalDetailsList = Object.keys(mainInfo).map((key) => {
    return (
      <li key={key} className={itemStyles}>
        <span className={classes.infoKey}>{key}:</span>
        {mainInfo[key]}
      </li>
    );
  });

  return (
    <div className={classes.contentWrapper}>
      <ul className={classes.proposalInfoList}>{proposalDetailsList}</ul>
      {actionsSection && <div className={classes.actionsSection}>{actionsSection}</div>}
    </div>
  );
};

export default InfoSection;
